export const SAMPLE_PHONE = '+48 735 440 434';
export const SAMPLE_URL = 'https://www.agronetpro.com/';
export const PLACEHOLDERS = ['{daysLeft}', '{blockDate}', '{contactPhone}', '{contactUrl}'];

const pad = n => String(n).padStart(2, '0');

// Replaces the placeholders with example values, for the phone preview only.
export const fillSample = (text, daysLeft = 5) => {
    const date = new Date(Date.now() + daysLeft * 86400000);
    const blockDate = `${pad(date.getDate())}.${pad(date.getMonth() + 1)}.${date.getFullYear()} ${pad(date.getHours())}:${pad(date.getMinutes())}`;
    return (text || '')
        .replace(/\{daysLeft\}/g, String(daysLeft))
        .replace(/\{blockDate\}/g, blockDate)
        .replace(/\{contactPhone\}/g, SAMPLE_PHONE)
        .replace(/\{contactUrl\}/g, SAMPLE_URL);
};

export const isHttpsUrl = value => {
    try {
        const url = new URL(value);
        return url.protocol === 'https:' && !!url.hostname;
    } catch (e) {
        return false;
    }
};

export const isRouteKey = value => /^[A-Za-z0-9_./?=&%-]{1,200}$/.test(value);

export const phaseLabel = (t, phase) => ({
    WAITING_FIRST_SHOW: t.gettext('Waiting for first display'),
    WARNING: t.gettext('Warning shown'),
    BLOCKING: t.gettext('Blocked'),
    INACTIVE: t.gettext('Inactive')
}[phase] || phase);

export const actionLabel = (t, notice) => {
    if (notice.actionType === 'DEEP_LINK') {
        return `${t.gettext('Open screen')}: ${notice.actionTarget}`;
    }
    if (notice.actionType === 'WEB_PAGE') {
        return t.gettext('Open web page');
    }
    return t.gettext('No button');
};
